import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

import { UserDtoProfileEnum } from 'lib_api/lib/api/gen';

import { NotFoundPage } from 'components/Error';
import FAQ from 'components/FAQ';
import MentionsLegales from 'components/MentionsLegales';
import ProfileWrapper from 'components/ProfileWrapper';
import Tutorial from 'components/Tutorial/Tutorial';
import { useUserStore } from 'hooks/UserStoreContext';
import AdminRouter from 'pages/admin-fonctionnel/AdminRouter';
import AfRouter from 'pages/autorite-fourriere/AfRouter';
import DsrRouter from 'pages/delegue-securite-routiere/DsrRoutes';
import FoRouter from 'pages/forces-de-l-ordre/FoRouter';
import GfRouter from 'pages/gardien-fourriere/GfRouter';
import JusticeRouter from 'pages/justice/JusticeRouter';
import { NOT_FOUND_PATH, profileEnumMapping } from 'utils/enumData';

import AuthGuard from './AuthGuard';

const AppRoutes: React.FC = () => {
  const user = useUserStore();
  const { mentionsLegalesPath, profilPath, faqPath, tutorielPath } =
    profileEnumMapping[user.profile];

  return (
    <Routes>
      {/* Common routes */}
      {profilPath && <Route path={profilPath} element={<ProfileWrapper />} />}
      {faqPath && <Route path={faqPath} element={<FAQ />} />}
      {tutorielPath && <Route path={tutorielPath} element={<Tutorial />} />}
      <Route path={mentionsLegalesPath} element={<MentionsLegales />} />
      <Route path={NOT_FOUND_PATH} element={<NotFoundPage />} />
      <Route path="*" element={<Navigate replace to={NOT_FOUND_PATH} />} />

      {user.profile !== null && (
        <Route
          path="/"
          element={<Navigate to={profileEnumMapping[user.profile].homePath} />}
        />
      )}

      {/* Specific routes for GF */}
      <Route
        path={profileEnumMapping[UserDtoProfileEnum.GARDIEN_FOURRIERE].rootPath}
        element={
          <AuthGuard roles={[UserDtoProfileEnum.GARDIEN_FOURRIERE]}>
            <GfRouter />
          </AuthGuard>
        }
      />

      {/* Specific routes for Justice profiles, THEY SHARE THE SAME rootPath */}
      <Route
        path={profileEnumMapping[UserDtoProfileEnum.NATIONAL_JUSTICE].rootPath}
        element={
          <AuthGuard
            roles={[
              UserDtoProfileEnum.COUR_APPEL,
              UserDtoProfileEnum.TRIBUNAL_JUDICIAIRE,
              UserDtoProfileEnum.UNITE_OPERATIONNELLE,
              UserDtoProfileEnum.NATIONAL_JUSTICE,
            ]}
          >
            <JusticeRouter />
          </AuthGuard>
        }
      />

      {/* Specific routes for AF */}
      <Route
        path={
          profileEnumMapping[UserDtoProfileEnum.AUTORITE_FOURRIERE].rootPath
        }
        element={
          <AuthGuard roles={[UserDtoProfileEnum.AUTORITE_FOURRIERE]}>
            <AfRouter />
          </AuthGuard>
        }
      />

      {/* Specific routes for FO */}
      <Route
        path={profileEnumMapping[UserDtoProfileEnum.FORCE_DE_L_ORDRE].rootPath}
        element={
          <AuthGuard roles={[UserDtoProfileEnum.FORCE_DE_L_ORDRE]}>
            <FoRouter />
          </AuthGuard>
        }
      />

      {/* Specific routes for DSR */}
      <Route
        path={profileEnumMapping[UserDtoProfileEnum.DSR_BLR].rootPath}
        element={
          <AuthGuard roles={[UserDtoProfileEnum.DSR_BLR]}>
            <DsrRouter />
          </AuthGuard>
        }
      />

      {/* Specific routes for Admin */}
      <Route
        path={profileEnumMapping[UserDtoProfileEnum.ADMIN_FONCTIONNEL].rootPath}
        element={
          <AuthGuard roles={[UserDtoProfileEnum.ADMIN_FONCTIONNEL]}>
            <AdminRouter />
          </AuthGuard>
        }
      />
    </Routes>
  );
};

export default AppRoutes;
